import { useAuthStore } from 'store/authStore';
 
export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    login, 
    forgotPassword,
    changePassword,
    logout,
    updateUser,
    clearError,
  } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login, 
    forgotPassword,
    changePassword,
    logout,
    updateUser,
    clearError,
  };
};

